import GameStepBase from '../game_step_base';

export default class ReadHistoryGameConfigurationGameStep extends GameStepBase {
    static CLASS = 'ReadHistoryGameConfigurationGameStep';

    run(gameOptions) {
        return this.serviceFactory.gameService().readHistoryGameConfiguration(gameOptions).then(gameConfiguration => Object.assign(gameOptions, gameConfiguration));
    }
}